import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'AlertDialog' })((theme) => ({
  textContent: {
    color: theme.palette.text.primary,
    margin: 'auto',
    padding: 0,
  },
  textArea: {
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
